/**
 *  AudioManager
 *
 *  Created by Legman on 25/02/2016.
 *
 */

var Audio                   = require("./Audio");
var AudioParams             = require("./AudioParams");

function AudioManager() {
    /**
     * @type {object}
     * @private
     */
    this._cache = {};

    /**
     * @type {Howl}
     * @private
     */
    this._music = null;

    /**
     * @type {boolean}
     * @private
     */
    this._isMuted = false;

    var hidden;
    "undefined" != typeof document.hidden ? (hidden = "hidden",
        this.visibilityChange = "visibilitychange")     : "undefined" != typeof document.mozHidden  ? (hidden = "mozHidden",
        this.visibilityChange = "mozvisibilitychange")  : "undefined" != typeof document.msHidden   ? (hidden = "msHidden",
        this.visibilityChange = "msvisibilitychange")   : "undefined" != typeof document.webkitHidden && (hidden = "webkitHidden",
        this.visibilityChange = "webkitvisibilitychange");

    document.addEventListener(this.visibilityChange, function(){
        document[hidden] ? Howler.volume(0) : Howler.volume(1);
    }, false);

}
module.exports = AudioManager;

/**
 * @param {!Array.<string>} sounds
 * @param {!Array.<string>} extensions
 * @param {string=} basePath
 */
AudioManager.prototype.addSounds = function(sounds, extensions, basePath) {
    basePath = basePath || "";

    var howl, name, url, urls, extension, i, j;
    for (i = 0; i < sounds.length; ++ i) {
        url     = basePath + sounds[i];
        url     = url.split("/");
        name    = url[url.length - 1];

        urls = [];
        for (j = 0; j < extensions.length; ++ j) {
            extension = extensions[j];
            urls.push(url.join("/") + extension);
        }
        howl = new Howl({
            src: urls,
            volume: 1.0,
            loop: false,
            autoplay: false
        });
        howl.name = name;
        this._cache[name] = howl;
    }
};

/**
 * @param {!Array.<string>} name
 * @param {!Array.<string>} sprite
 * @param {!Array.<string>} extensions
 * @param {string=} basePath
 */
AudioManager.prototype.addSoundSprite = function(name, sprite, extensions, basePath) {
    basePath = basePath || "";

    var extension;

    var url = basePath + name;
    url = url.split("/");

    var urls = [];
    for (var i = 0; i < extensions.length; ++ i) {
        extension = extensions[i];
        urls.push(url.join("/") + extension);
    }

    var howl = new Howl({
        src: urls,
        sprite: sprite,
        volume: 1,
        loop: false,
        autoplay: false
    });
    howl.isSoundSprite = true;
    for (var key in sprite) {
        if (sprite.hasOwnProperty(key)) {
            this._cache[key] = howl;
        }
    }
};

/**
 * @param {!Array.<string>} sounds
 */
AudioManager.prototype.removeSounds = function(sounds) {
    var name, n, howl;
    for (var i = 0; i < sounds.length; ++ i) {
        name = sounds[i];
        for (n in this._cache) {
            if (this._cache.hasOwnProperty(key)) {
                howl = this._cache[key];
                if (howl.name === n) {
                    howl.unload();
                    delete this._cache[name];
                    break;
                }
            }
        }
    }
};

/**
 * @param {!string | Array.<string>} name
 * @param {AudioParams=} params
 * @returns {Audio}
 */
AudioManager.prototype.playSound = function(name, params) {
    params = params || new AudioParams();

    var id = -1;

    if (typeof name !== "string") {
        name = name[Math.floor(Math.random() * name.length)];
    }

    var howl = this._cache[name];
    if (!howl) {
        console.warn("Could not find sound - " + name);
        return id;
    }

    id = howl.isSoundSprite ? howl.play(name) : howl.play();
    howl.volume(params.volume, id);
    howl.loop(params.loop, id);

    var audio = new Audio();
    audio.id = id;
    audio.howl = howl;

    if (params.callback) {
        audio._onend = function() {
            params.callback.call(params.scope);
        };
        howl.on("end", audio._onend);
    }

    return audio;
};

/**
 * @param {!string | Array.<string>} name
 * @param {AudioParams=} params
 * @returns {Audio}
 */
AudioManager.prototype.playMusic = function(name, params) {
    params = params || new AudioParams();

    var id = -1;

    if (typeof name !== "string") {
        name = name[Math.floor(Math.random() * name.length)];
    }

    // skip if no change
    if (this._music && this._music.howl.name === name) {
        return this._music;
    }

    var howl = this._cache[name];
    if (!howl) {
        console.warn("Could not find music - " + name);
        return null;
    }

    if (p3.Device && p3.Device.isAndroidStockBrowser) {
        howl.buffer = true;
    }

    id = howl.play();
    howl.volume(params.volume, id);
    howl.loop(true, id);

    var audio = new Audio();
    audio.id = id;
    audio.howl = howl;

    if (params.callback) {
        audio._onend = function() {
            params.callback.call(params.scope);
        };
        howl.on("end", audio._onend);
    }

    if (params.fadeIn > 0.0) {
        if (this._music) {
            this.fadeOut(this._music, params.fadeIn, function(audio) {
                audio.destroy();
            }, this);
        }
        this.fadeIn(audio, params.fadeIn);
    } else {
        this.stopMusic();
    }

    this._music = audio;
    return audio;
};

/**
 * @param {!string} name
 * @param {number=} id
 * @deprecated
 */
AudioManager.prototype.stopSound = function(name, id) {
    var howl = this._cache[name];
    !howl && console.warn("Could not find sound - " + name);
    howl.stop(id);

    console.warn("'AudioManager.stopSound()' is deprecated. Use 'Audio.stop()' instead.");
};

AudioManager.prototype.stopMusic = function() {
    if (!this._music) return;

    this._music.destroy();
    this._music = null;
};

/**
 * @param {!boolean} value
 */
AudioManager.prototype.mute = function(value) {
    this._isMuted = value;
    if (this._isMuted) {
        Howler.mute(true);
    } else {
        Howler.mute(false);
    }
};

/**
 * @param {!Audio} audio
 * @param {number=} duration
 * @param {function=} callback
 * @param {*=} scope
 */
AudioManager.prototype.fadeIn = function(audio, duration, callback, scope) {
    duration = duration || 1.0;

    var volume = audio.howl.volume(audio.id);
    audio.howl.volume(0.0, audio.id);
    audio.__volume = 0.0;

    TweenMax.killTweensOf(audio);
    TweenMax.to(audio, duration, {
        __volume: volume,
        ease: Power1.easeInOut,
        onUpdate: function() {
            audio.howl.volume(audio.__volume, audio.id);
        },
        onUpdateScope: this,
        onComplete: callback,
        onCompleteParams: [audio],
        onCompleteScope: scope
    });
};

/**
 * @param {!Audio} audio
 * @param {number=} duration
 * @param {function=} callback
 * @param {*=} scope
 */
AudioManager.prototype.fadeOut = function(audio, duration, callback, scope) {
    duration = duration || 1.0;

    audio.__volume = audio.howl.volume(audio.id);

    TweenMax.killTweensOf(audio);
    TweenMax.to(audio, duration, {
        __volume: 0.0,
        ease: Power1.easeInOut,
        onUpdate: function() {
            audio.howl.volume(audio.__volume, audio.id);
        },
        onUpdateScope: this,
        onComplete: callback,
        onCompleteParams: [audio],
        onCompleteScope: scope
    });
};

/**
 * @param {!Audio} audio
 * @param {!*} object
 * @param {!Camera} camera
 * @param {number=} min
 * @param {number=} max
 */
AudioManager.prototype.setAudioPos3D = function(audio, object, camera, min, max) {
    if (p3.Device.isMobile || !p3.Device.bowser["chrome"]) return;

    min = min || 0.0;
    max = max || 320.0;

    var layer = camera.findLayerForObject(object);
    var x = object.x * (1.0 / layer.parallax.x);
    var sign = (x - camera.position.x);
    sign = sign / Math.abs(sign);

    if (sign == -1) x = Math.min(0.0, ((x + min) - camera.position.x) / (max - min));
    else if (sign == 1) x = Math.max(0.0, ((x - min) - camera.position.x) / (max - min));

    audio.howl.pos(x, 0.0, 0.0, audio.id);
};

/**
 * @param {Audio} audio
 * @param {*} object
 * @param {Camera} camera
 * @param {!number} [min]
 * @param {!number} [max]
 * @param {!number} [offset]
 * @param {boolean} [fallback]
 */
AudioManager.prototype.setAudioPosStereo = function(audio, object, camera, min, max, offset, fallback) {
    if (p3.Device.isMobile || !p3.Device.bowser["chrome"]) {
        fallback = true;
    }

    min = min || 0.0;
    max = max || 320.0;
    offset = offset || 0;

    var layer = camera.findLayerForObject(object);
    var x = (object.x + offset) * (1.0 / layer.parallax.x);
    var sign = (x - camera.position.x);
    sign = sign / Math.abs(sign);

    x = Math.max(0.0, Math.abs((x - min) - camera.position.x) / (max));
    x = Math.max(0.0, Math.min(1.0, 1.0 + (1.0 - x)));

    audio.howl.volume(x, audio.id);

    if (fallback) return;

    x = (object.x + offset) * (1.0 / layer.parallax.x);

    if (sign == -1) x = Math.min(0.0, ((x + min) - camera.position.x) / (max - min));
    else if (sign == 1) x = Math.max(0.0, ((x - min) - camera.position.x) / (max - min));

    x = Math.max(-1.0, Math.min(1.0, x));
    audio.howl.stereo(x, audio.id);
};

Object.defineProperty(AudioManager.prototype, "isMute", {
    /**
     * @returns {!boolean}
     */
    get: function() {
        return this._isMuted;
    }
});
